<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <b>我的徒弟</b>
      </div>
      <div class="right">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            {{ custom }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in dropDownData"
              :key="index"
              :command="{ value: item.val, label: item.label }"
              >{{ item.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <section class="uc-teacherList ">
      <div class="row list uc-pb20">
        <div class="content-empty" v-if="list.length == 0">
          <div class="emptyimg-box"></div>
          <p>暂无相关内容</p>
        </div>
        <div v-for="(item, index) in list" :key="index" class="col-8 box">
          <router-link
            :to="{
              name: 'ShituMasterApprenticeDetails',
              params: { id: item.id },
            }"
          >
            <div class="item shitu">
              <div class="face shitu">
                <el-image
                  :src="item.apprentice_avatar"
                  onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
                ></el-image>
              </div>
              <h3>{{ item.apprentice_name }}</h3>
              <div class="info shitu">
                <p>师徒期限：{{ item.limit_time }} 个月</p>
                <p>关系开始：{{ item.start_time }}</p>
                <p v-if="item.status !== 1">关系结束：{{ item.end_time }}</p>
                <p>
                  关系状态：<el-tag
                    v-if="item.status == 1"
                    type="success"
                    size="small"
                  >
                    {{ item.status_text }}
                  </el-tag>
                  <el-tag v-else type="warning" size="small">
                    {{ item.status_text }}
                  </el-tag>
                </p>
              </div>
              <div class="btm">
                <div class="l">
                  <router-link
                    :to="{
                      name: 'ShituMasterLog',
                      params: { id: item.apprentice_id },
                    }"
                  >
                    <i class="el-icon-date"></i> 日志·{{ item.log_count }}
                  </router-link>
                </div>
                <div>
                  <router-link
                    :to="{
                      name: 'ShituMasterCommunication',
                      params: { id: item.apprentice_id },
                    }"
                  >
                    <i class="el-icon-chat-dot-round"></i> 沟通·{{
                      item.communication_count
                    }}
                  </router-link>
                </div>
                <div class="r">
                  <router-link
                    :to="{
                      name: 'ShituMasterApprenticeTask',
                      params: { id: item.apprentice_id },
                    }"
                  >
                    <i class="el-icon-s-operation"></i> 任务·{{
                      item.task_count
                    }}
                  </router-link>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MasterApprentice',
  data() {
    return {
      custom: '存续',
      dropDownData: [
        { label: '存续', val: 1 },
        { label: '手动解除', val: 2 },
        { label: '自动解除', val: 3 },
      ],
      query: {
        type: 1,
        relationStatus: undefined,
      },
      list: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getShituRelations();
    },
    async getShituRelations() {
      const response = await this.$api.shitu.getShituRelations(this.query);
      this.list = response.data.data;
    },
    handleCommand(command) {
      this.custom = command.label;
      this.query.relationStatus = command.value;
      this.initData();
    },
  },
};
</script>
